import { useEffect } from 'react'
import useSessionStorage from 'lib/useSessionStorage'
import { parse } from 'qs'

const utm_keys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_adgroup',
]

const click_id_keys = [
  'gclid',
  'msclkid',
  'fbclid',
  'li_fat_id',
]

// Facebook cookie keys set by Meta Pixel
const fb_cookie_keys = ['_fbp', '_fbc']

/**
 * Get cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
function getCookie(name) {
  if (typeof document === 'undefined') return null
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

/**
 * Generate fbc (Facebook Click ID) format from fbclid
 * Format: fb.{subdomainIndex}.{creationTime}.{fbclid}
 * @param {string} fbclid - Facebook Click ID from URL
 * @returns {string} - Formatted fbc value
 */
function generateFbc(fbclid) {
  const timestamp = Date.now()
  return `fb.1.${timestamp}.${fbclid}`
}

export default function useSessionData(key = 'user_session', initialData = {}) {
  const [data, setData] = useSessionStorage(key, initialData)

  useEffect(() => {
    const meta = {}

    if (!data.meta || !data.meta.origin_url) {
      meta.origin_url = window.location.pathname
    }

    const query = parse(location.search.substr(1))

    utm_keys.forEach(key => {
      const val = query[key]

      if (val) {
        meta[key] = val
      }
    })

    click_id_keys.forEach(key => {
      const val = query[key]

      if (val) {
        meta[key] = val
      }
    })

    // Capture Facebook cookies (_fbp and _fbc) set by Meta Pixel
    fb_cookie_keys.forEach(cookieKey => {
      const cookieValue = getCookie(cookieKey)
      if (cookieValue) {
        // Store without underscore prefix (e.g., _fbp -> fbp)
        meta[cookieKey.replace('_', '')] = cookieValue
      }
    })

    // If we have fbclid from URL but no _fbc cookie, generate fbc format
    // This ensures we have fbc for Conversions API even without Meta Pixel
    if (query.fbclid && !getCookie('_fbc') && !meta.fbc) {
      meta.fbc = generateFbc(query.fbclid)
    }

    if (Object.keys(meta).length) {
      setData({
        ...data,
        meta: {
          ...data.meta,
          ...meta,
        }
      })
    }
  }, [])

  return [data, setData]
}
